<template>
  <div class="sub2">

    <lnb></lnb>

    <!--SECTION-->
    <section class="sec1">
      <img src="img/visual_sub2.png" alt="" class="bg">

      <div class="filter">
        <div class="pink_box"></div>
        <img src="img/filter_title.png" alt="" class="title">
        <div class="scroll1 dropdown">
          <img src="img/filter_bride.png" alt="">
          <img src="img/filter_bride_hover.png" alt="" class="hover">
        </div>

        <ul class="btn clearfix">
          <li><a><img src="img/filter_producttype.png" alt=""></a></li>
          <li><img src="img/filter_bar.png" alt=""></li>
          <li><a><img src="img/filter_color.png" alt=""></a></li>
          <li><img src="img/filter_bar.png" alt=""></li>
          <li><a><img src="img/filter_size.png" alt=""></a></li>
          <li><img src="img/filter_bar.png" alt=""></li>
          <li><a><img src="img/filter_heelheight.png" alt=""></a></li>
        </ul>

        <div class="scroll2 dropdown">
          <img src="img/filter_sortby.png" alt="">
          <img src="img/filter_sortby_hover.png" alt="" class="hover">
        </div>
      </div>
    </section>


    <!--SECTION-->
    <section class="sec2">
      <div class="inner">
        <a @click="changeContentsName('Sub3')">
          <img src="img/pic_shop.png" alt="" class="pic">
        </a>
      </div>
    </section>

  </div>
</template>

<script>
  import { mapMutations } from 'vuex'
  import Lnb from './Lnb.vue'

  export default {
    name: 'Sub2Page',
    components: {
      Lnb
    },
    data () {
      return {

      }
    },
    methods: {
      ...mapMutations([
        'changeContentsName'
      ])
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Sub2Page.vue